// Shared deliverable definitions for campaigns
// Used across brand and influencer UIs

export const DELIVERABLES = {
  instagram_post: { label: 'Instagram Post (Feed)', platform: 'Instagram' },
  instagram_story: { label: 'Instagram Story', platform: 'Instagram' },
  instagram_reel: { label: 'Instagram Reel', platform: 'Instagram' },
  tiktok_video: { label: 'TikTok Video', platform: 'TikTok' },
  youtube_short: { label: 'YouTube Short', platform: 'YouTube' },
  ugc_video: { label: 'UGC Video (unposted)', platform: 'UGC' },
};

/**
 * Get the human-readable label for a deliverable key
 * @param {string} key - The deliverable key (e.g., "instagram_post")
 * @returns {string} - The label (e.g., "Instagram Post (Feed)")
 */
export function deliverableLabel(key) {
  if (!key) return '';
  return DELIVERABLES[key]?.label || key;
}

/**
 * Get human-readable labels for an array of deliverable keys
 * @param {string[]} keys - Array of deliverable keys
 * @returns {string[]} - Array of labels
 */
export function deliverableLabels(keys = []) {
  if (!Array.isArray(keys)) return [];
  return keys.map(deliverableLabel).filter(Boolean);
}

/**
 * Get all deliverable keys
 * @returns {string[]} - Array of all deliverable keys
 */
export function getAllDeliverableKeys() {
  return Object.keys(DELIVERABLES);
}



